import { render } from "./ModalEditarCategoria.vue?vue&type=template&id=daf38186&scoped=true"
import script from "./ModalEditarCategoria.vue?vue&type=script&lang=js"
export * from "./ModalEditarCategoria.vue?vue&type=script&lang=js"

import "./ModalEditarCategoria.vue?vue&type=style&index=0&id=daf38186&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daf38186"]])

export default __exports__